import React from 'react';
import Button from '@scalero-inc/forno-button';
import { Link, useLocation } from 'react-router-dom';

import styles from './styles.module.css';

function PricingAndFeaturesSection() {
  const location = useLocation();

  React.useEffect(() => {
    if (location.hash === '#services-pricing') {
      const pricing = document.getElementById('services-pricing');
      if (pricing) pricing.scrollIntoView();
    } else {
      const root = document.getElementById('root');
      if (root) root.scrollIntoView();
    }

    return () => {};
  }, [location]);

  return (
    <>
      <div className={styles.divider} />
      <section className={styles.servicesSection} id="services-pricing">
        <h1>Pricing and Features</h1>
        <p className="paragraph-l">
          All of our emails are optimized and ready to go.
          <br />
          When making an order you will receive:
        </p>
        <div className={styles.outerCard}>
          <div className={styles.innerCard}>
            <div className={styles.column}>
              <h2>$75 USD</h2>
              <span className={styles.tag}>per email</span>
              <h4>Each order is delivered within 2 business days.</h4>
              <Link to="checkout/">
                <Button size="s">Order now</Button>
              </Link>
              <div className={styles['anchor-button']}>
                <Link to="/policies/services">
                  <Button hierarchy="tertiary" size="s">
                    Take a look at our policies
                  </Button>
                </Link>
              </div>
            </div>
            <div className={styles.columnDivider} />
            <ul className={styles.columnList}>
              <li className="paragraph-r">Responsive email code.</li>
              <li className="paragraph-r">HTML file.</li>
              <li className="paragraph-r">
                HTML and MJML code inside Cannoli.
              </li>
              <li className="paragraph-r">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.emailonacid.com/"
                >
                  Email On Acid
                </a>{' '}
                email previews.
                <br />
                <span className={`paragraph-r ${styles.paragraphRStyled}`}>
                  Tests on 80+ devices and email clients
                </span>
              </li>
              <li className="paragraph-r">
                An optimized Figma file for further Cannoli usage.
              </li>
              <li className="paragraph-r">
                Validation for links and images.
                <br />
                <span className={`paragraph-r ${styles.paragraphRStyled}`}>
                  Alt text and valid URLs
                </span>
              </li>
              <li className="paragraph-r">
                Built in AI generated font stacks.
              </li>
              <li className="paragraph-r">Dark mode asset optimization.</li>
              <li className="paragraph-r">Outlook 120 DPI optimization.</li>
            </ul>
          </div>
          <p className="paragraph-r">
            Make sure to request any special additions when placing your order.
            <br />
            We can’t guarantee extra additions can be made after that.
          </p>
          <Link to="/services#looking-for-more">
            <Button size="s" hierarchy="tertiary">
              Special additions
            </Button>
          </Link>
        </div>
      </section>
    </>
  );
}

export default PricingAndFeaturesSection;
